// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"7863": "ab041ccf","8561": "f9cad78a","8990": "7d69c8cd",}[chunkId] + ".css"
}